import { Button, styled } from '@/theme/index';

export const ReportActionButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0.25, 0.75),
  color: theme.palette.primary.main,
  fontSize: '0.875rem',
  lineHeight: 1.2,
  height: '100%',
  minWidth: '65px',

  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(0.5),
    minWidth: '64px',
  },

  '&.pdf-action': {
    display: 'none',

    '&.show': { display: 'inline-flex' },

    [theme.breakpoints.up('sm')]: {
      display: 'inline-flex',
    },
  },

  '.MuiButton-startIcon': {
    margin: 0,
    '.MuiSvgIcon-root': {
      fontSize: '1rem',
    },
  },

  [theme.breakpoints.up('sm')]: {
    fontWeight: 400,
    fontSize: '1rem',
    paddingBlock: theme.spacing(1.3125),
    paddingInline: 'unset',

    '.MuiButton-startIcon': {
      margin: 0,
      '.MuiSvgIcon-root': {
        fontSize: '1.25rem',
      },
    },
  },
}));
